<template>
  <div class="allOrder">
    <div class="order-title">
      <ul>
        <li @click="getList(1,1,1)" :class=" isType == 1? 'active' : ' ' ">全部订单</li>
        <li @click="getList(2,1,1)" :class="isType == 2 ? 'active' : ' '">近一个月</li>
        <li @click="getList(3,1,1)" :class="isType == 3 ? 'active' : ' '">近三个月</li>
      </ul>
    </div>
    <cube-scroll
      ref="scroll"
      :data="items"
      :options="options"
      @pulling-down="onPullingDown"
      @pulling-up="onPullingUp" class="page_scroll">
      <div class="noDataTip notice" v-if="info.length===0">
        <dl>
          <dt></dt>
          <dd>暂无数据</dd>
        </dl>
      </div>
      <div class="order-list-content">
        <div class="ul-box" v-if="isType == 1">
          <div v-for="(item, index) in info" :key='index'>
            <router-link :to="{ name:'orderDetail', params: { order_id: item.order_id}}">
              <style-list :info='item' :type='type'></style-list>
            </router-link>
          </div>
        </div>
        <div class="ul-box" v-if="isType == 2">
          <div v-for="(item, index) in info" :key='index'>
            <router-link :to="{ name:'orderDetail', params: { order_id: item.order_id}}">
              <style-list :info='item' :type='type'></style-list>
            </router-link>
          </div>
        </div>
        <div class="ul-box" v-if="isType == 3">
          <div v-for="(item, index) in info" :key='index'>
            <router-link :to="{ name:'orderDetail', params: { order_id: item.order_id}}">
              <style-list :info='item' :type='type'></style-list>
            </router-link>
          </div>
        </div>
      </div>
    </cube-scroll>
  </div>
</template>
<script>
   import styleList from './views/styleList'

   export default {
      name: 'allOrder',
      data() {
         return {
            user_id: localStorage.getItem('user_id'),
            orderListType: this.$route.params.orderListType,
            items: [],
            isType: 1,
            options: {
               pullUpLoad: {
                  threshold: 60,
                  txt: {
                     more: '加载更多',
                     // noMore: '没有更多了'
                  },
                  visible: false
               },
               pullDownRefresh: {
                  threshold: 60,
                  txt: '刷新成功'
               },
            },
            info: [],
            pageNum: 1,
            allpage: null,
            type: 'allOrder',
            // numeberNow: 0
         }
      },
      created() {
         // this.$loading.show()
         this.getList(1, 1, 1)
      },
      methods: {
         getList(number, pageNum, type) {
            let _this = this
            this.isType = number
            // 业务员
            if (this.orderListType == 2) {

               this.$http.api.findOrderByTime({
                  page: pageNum,
                  size: 10,
                  user_id: this.user_id,
                  timeStyle: number
               }).then(result => {
                  // this.$loading.hide()
                  _this.allpage = Math.ceil(result.total / 10)
                  let data = result.rows
                  // 待确定，购买成功，购买失败 状态
                  // data = result.rows.map(item => {
                  //   return Object.assign({}, item, {    //时间格式化
                  //     order_status: status[item.order_status -1],
                  //   });
                  // });
                  if (type === 1) {
                     _this.info = [...data]
                     _this.$refs.scroll.forceUpdate()
                     _this.pageNum = 2
                  } else {
                     // console.log(_this.pageNum,_this.allpage)
                     if (data.length > 0 && _this.pageNum <= _this.allpage) {
                        _this.info = _this.info.concat(data)
                        _this.pageNum = _this.pageNum + 1
                        setTimeout(function () {
                           _this.$refs.scroll.forceUpdate()
                        }, 300)
                     } else {
                        //  console.log(2)
                     }
                  }
               })
               if (_this.pageNum > _this.allpage) {
                  setTimeout(function () {
                     _this.$refs.scroll.forceUpdate()
                  }, 300)
               }
            } else if (this.orderListType == 3) {
               this.$http.api.doctorOrders({
                  page: pageNum,
                  size: 10,
                  user_id: this.user_id,
                  timeStyle: number
               }).then(result => {
                  // this.$loading.hide()
                  _this.allpage = Math.ceil(result.total / 10)
                  let data = result.rows
                  // 待确定，购买成功，购买失败 状态
                  // data = result.rows.map(item => {
                  //   return Object.assign({}, item, {    //时间格式化
                  //     order_status: status[item.order_status -1],
                  //   });
                  // });
                  if (type === 1) {
                     _this.info = [...data]
                     _this.$refs.scroll.forceUpdate()
                     _this.pageNum = 2
                  } else {
                     // console.log(_this.pageNum,_this.allpage)
                     if (data.length > 0 && _this.pageNum <= _this.allpage) {
                        _this.info = _this.info.concat(data)
                        _this.pageNum = _this.pageNum + 1
                        setTimeout(function () {
                           _this.$refs.scroll.forceUpdate()
                        }, 300)
                     } else {
                        //  console.log(2)
                     }
                  }
               })
               if (_this.pageNum > _this.allpage) {
                  setTimeout(function () {
                     _this.$refs.scroll.forceUpdate()
                  }, 300)
               }
            }

         },
         onPullingDown() {
            // this.isLoading = false
            this.getList(this.isType, 1, 1)
         },
         onPullingUp() {
            let _this = this
            // _this.isLoading = false
            setTimeout(function () {
               // console.log(this.isType)
               _this.getList(_this.isType, _this.pageNum, 2)
            }, 800)
         },
      },
      components: {
         styleList
      }
   }
</script>
<style lang="less" scoped>
  .page_scroll {
    top: 61px;
    bottom: 0;
  }

  .allOrder {
    width: 100%;
    overflow: hidden;

    .noDataTip {
      width: 100%;
      text-align: center;
      padding-top: 20px;
    }

    .order-title {
      width: 100%;
      height: 60px;
      background: #61B0E3;
      overflow: hidden;

      ul {
        margin: 0 10px;
        box-sizing: border-box;
        height: 31px;
        margin-top: 14px;

        li {
          width: 33.33%;
          height: 31px;
          color: #61B0E3;
          background: #fff;
          float: left;
          font-size: 12px;
          text-align: center;
          line-height: 31px;

          &:nth-child(1) {
            border-top-left-radius: 15px;
            border-bottom-left-radius: 15px;
          }

          &:nth-child(2) {
            border-left: 1px solid #61B0E3;
            border-right: 1px solid #61B0E3;
          }

          &:nth-child(3) {
            border-top-right-radius: 15px;
            border-bottom-right-radius: 15px;
          }
        }

        .active {
          background: #61B0E3;
          color: #fff;
          border: 1px solid #B0D8F1;
        }
      }
    }

    .order-list-content {
      width: 100%;
      height: auto;

      .ul-box {
        width: 100%;
        // li {
        //   width: 100%;
        //   height: 110px;
        //   p {
        //     width: 100%;
        //     background: #fff;
        //     font-size: 14px;
        //     color: #333333;
        //   }
        //   .list-title {
        //     height: 36px;
        //     line-height: 36px;
        //     background: #FBFBFB;
        //     border: 1px solid #E6E6E6;
        //     border-left: none;
        //     border-right: none;
        //     position: relative;
        //     i{
        //       color: #60B0E3;
        //     }
        //     span:nth-child(1){
        //       // margin-left: 10px;
        //       position: absolute;
        //       left: 10px;
        //       height: 36px;
        //       line-height: 36px;
        //     }
        //     .colorSuccess{
        //       height: 36px;
        //       line-height: 36px;
        //       position: absolute;
        //       right: 10px;
        //       color: #60B0E3;
        //     }
        //     .colorStatus{
        //       height: 36px;
        //       line-height: 36px;
        //       position: absolute;
        //       right: 10px;
        //       color: #CCCCCC;
        //     }

        //   }
        //   .list-content {
        //     width: 100%;
        //     height: 90px;
        //     padding-top: 10px;
        //     padding-left: 10px;
        //     position: relative;
        //     a{
        //       width: 100px;
        //       height: 50px;
        //       // overflow: hidden;
        //       display: block;
        //       // margin-left: 10px;
        //       // box-sizing: border-box;
        //       position: absolute;
        //       left: 10px;
        //       img {
        //         width: 100px;
        //         height: 50px;
        //       //   margin-top: 10px;
        //       }
        //     }
        //     .content-box {
        //        width: 60%;
        //        display: inline;
        //        position: absolute;
        //        left: 120px;
        //        text-align: left;
        //        span {
        //         width: 100%;
        //         height: 20px;
        //         line-height: 20px;
        //         display: inline-block;
        //         white-space: nowrap;
        //         overflow: hidden;
        //         text-overflow: ellipsis;
        //        }
        //        span:nth-child(1) {
        //          font-size:16px;
        //          color:rgba(102,102,102,1);
        //        }
        //        span:nth-child(2) {
        //          font-size:10px;
        //          color:rgba(102,102,102,1);
        //        }
        //     }
        //   }
        // }
      }
    }

    //   .allOrder-list {
    //     padding: 0 10px;
    //     width: 100%;
    //     box-sizing: border-box;
    //     margin-top: 15px;
    //     li{
    //       width: 100%;
    //       height: 40px;
    //       line-height: 40px;
    //       background: #fff;
    //       margin-bottom: 5px;
    //       border-radius: 1px;
    //       border:1px solid rgba(0, 0, 0, 0.1);
    //       span{
    //         width: 33.33%;
    //         display: inline-block;
    //         height: 40px;
    //         overflow: hidden;
    //         white-space: nowrap;
    //         text-overflow: ellipsis;
    //         text-align: center;
    //         &:nth-child(1){
    //         }
    //       }
    //     }
    //   }
  }
</style>
